<template>
  <div :class="['home', 'home-background',{'home-background-heng': isHeng}]">
    <div v-if="isShowMask" class="wxMask" @click="isShowMask = false"></div>
      <div class="home__bottom">
          <div class="pics-wrap">
            <div id="J-swiper-1" :class="['swiper']">
              <div class="swiper-wrapper">
                <div :class="['swiper-slide', 'figure-pic']">
                  <div class="figure-pic__inner">
                    <img src="./images/mobile/swiper/1.png">
                  </div>
                </div>
                <div :class="['swiper-slide', 'figure-pic']">
                  <div class="figure-pic__inner">
                    <img src="./images/mobile/swiper/2.png">
                  </div>
                </div>
                <div :class="['swiper-slide', 'figure-pic']">
                  <div class="figure-pic__inner">
                    <img src="./images/mobile/swiper/3.png">
                  </div>
                </div>
                <div :class="['swiper-slide', 'figure-pic']">
                  <div class="figure-pic__inner">
                    <img src="./images/mobile/swiper/4.png">
                  </div>
                </div>
                <div :class="['swiper-slide', 'figure-pic']">
                  <div class="figure-pic__inner">
                    <img src="./images/mobile/swiper/5.png">
                  </div>
                </div>
                <div :class="['swiper-slide', 'figure-pic']">
                  <div class="figure-pic__inner">
                    <img src="./images/mobile/swiper/6.png">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="download-btns">
            <a
              v-if="isIOS"
              @click="download"
            >
              <button class="download-btn download-btns__btn-ios">下载游戏</button>
            </a>
            <a
              v-if="!isIOS"
              @click="download('andorid')"
           >
              <button class="download-btn download-btns__btn-android">下载游戏</button>
            </a>
            <!-- <div class="copyRight">
              <span ><a href="https://beian.miit.gov.cn/" style="color:#fff; text-decoration: underline;">沪B2-20050107-58</a></span><br/>
            </div> -->
          </div>
          <div class="footer">
            <div class="brand"></div>
            <div class="links">
              <a href="https://www.spaceparty.cn/user">用户协议</a> | <a href="https://www.spaceparty.cn/privacy">隐私政策</a> | <a href="https://www.spaceparty.cn/permission">应用权限</a> | <a href="https://beian.miit.gov.cn/">沪B2-20050107-58</a>
            </div>
            <div class="company">
              上海巨人统平网络科技有限公司<br>
              开发者：上海巨篷网络科技有限公司
            </div>
          </div>
          <div style="height:1.8rem;">

          </div>
      </div>
  </div>
</template>

<script>
/**
 * @description 是否是 andorid
 * @returns
 */
import { device, loadResources } from '@/utils/index'

function isInnerQQ () {
  return / QQ\/\d/.test(window.navigator.userAgent)
}

function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i)
  return ua && ua[0] === 'micromessenger'
  // return true
}

export default {
  data() {
    return {
      swiper: null,
      isHeng: false,
      isIOS: false,
      isShowMask: false
    }
  },

  mounted() {
    window._gtBuryPoint.send({
      event_name: '页面访问',
      page_name: '下载页'
    })

    this.isIOS = device.iOS()
    loadResources('https://games.spaceparty.cn/spaceshark/static/swiper9/swiper-bundle.min.js').then(() => {
      const event = new Event('swiper-inited')
      document.dispatchEvent(event)
    })

    document.addEventListener('swiper-inited', () => {
      setTimeout(() => {
        const swiper = new window.Swiper('#J-swiper-1', {
          spaceBetween: 5,
          slidesPerView: 1,
          centeredSlides: true,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          }
        })
        console.log(swiper)
      }, 0)
    })
  },
  methods: {
    handleOrientationChange(mql) {
      this.isHeng = !mql.matches
    },

    download(sys) {
      if (isInnerQQ() || isWeiXin()) {
        this.isShowMask = true
        return
      }
      window._gtBuryPoint.send({
        event_name: '下载点击',
        page_name: '下载页'
      })
      if (sys === 'andorid') {
        window.location.href = 'https://file.spaceparty.cn/apk_space/space_douyu_cps_129_1.40.14.002_safe.apk'
      } else {
        window.location.href = 'https://apps.apple.com/cn/app/%E5%A4%AA%E7%A9%BA%E8%A1%8C%E5%8A%A8-%E5%A4%AA%E7%A9%BA%E6%9D%80/id1658934469'
      }
    }
  }
}
</script>
<style lang="less" scoped>

@keyframes bounceIn {
  0% {
    transform: scale(1);
  }

  15% {
    transform: scale(0.9);
  }

  30% {
    transform: scale(1);
  }

  45% {
    transform: scale(0.9);
  }

  60% {
    transform: scale(1);
  }

  100% {
    transform: scale(1);
  }

}
@import '../../assets/less/mixin.less';
  .home-background {
    padding-top: 4.5rem;
    max-width: 600px;
    background-image: url(./images/mobile/bg.jpg), url(./images/mobile/bg-mini.jpg);
    background-size: 100% auto, 100% auto;
    background-repeat: no-repeat, no-repeat;
    margin: auto;
  }

  .wxMask{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.85);
    z-index: 99999;
    background-image: url('./images/open-to-brower.png');
    background-size: 96% auto;
    background-position: center 0;
    background-repeat: no-repeat;
  }

  .home__bottom{
    background-repeat: no-repeat;
    background-size: 100% auto;
    z-index: 1;
    .copyRight{
      opacity: 0.8;
      text-align: center;
      font-size: 0.14rem;
    }
  }

  .download-btns{
    padding-top: 0.27rem;
    position: fixed;
    height: 1.31rem;
    left: 0;
    right: 0;
    z-index: 100;
    bottom: 0;
    background-color: rgba(4,9,28,0.6);
    background-image: url('./images/mobile/zhezhao-mobile.png');
    background-position:  0 0;
    background-size: 100% auto;
    background-repeat: no-repeat;
    a{
      display: block;
      width: 100%;
      justify-content: center;
      font-size: 0.14rem;
      color: #fff;
    }
  }

  .pics-wrap{
    bottom: 0.85rem;
    opacity: 0.9;
    .swiper{
      width: 4rem;
      margin: 0 auto;
      .swiper-slide{
        // margin-right: 0px !important;
      }
      .swiper-slide{
        // width: 90% !important;
        margin: 0 5px;
      }
      .swiper-slide-prev{
          right: -5px;
      }
      .swiper-slide-next{
          left: -5px;
      }
    }
    .figure-pic__inner{
      border-radius: 5px;
      margin: 0 auto;
      width: 100%;
      img{
        max-width: 100%;
        border-radius: 5px;
      }
    }
  }

  .download-btn{
    display: block;
    margin: 0 auto;
    width: 3.17rem;
    height: 0.6rem;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    font-size: 0.2rem;
    font-weight: bold;
    background-color: #fbb712;
    //background: url('./images/download-btn.png') no-repeat;
    background-size: 100% auto;
    border-radius: 0.3rem;
    animation: bounceIn 2s infinite;
    //background-image: url(./static/assets/and.png);
    border: none;
    margin-bottom: 0.36rem;
  }

  .download-btns__btn-ios {
    //background-image: url(./images/download-btn-ios.png);
    //animation: unset;
    border: none;
  }

  .footer{
    .brand{
      margin: 0 auto;
      width: 1.89rem;
      height: 0.27rem;
      background-image: url('../home/images/mobile/brand.png');
      background-position: center 0;
      background-size: 100% auto;
      background-repeat: no-repeat;
      margin-bottom: 0.18rem;
    }
    .links,.company{
      text-align: center;
      color: #8E8E8E;
      font-size: 0.12rem;
      a{
        color: #8E8E8E;
        text-decoration: normal;
      }
    }
    .links{
      margin-bottom: 0.01rem;
    }

  }
</style>
